import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { DocumentArrowDownIcon } from '@heroicons/react/24/outline';
import fileDownload from 'js-file-download';
import Layout from './Layout';
import { SIDEBAR_STATUSES, VIEWS } from './constants';
import { showToast } from 'stores/ToastStore';
import getColumnDefinitions from './uvcolumnconfigdownload';
export default function UVColumnConfig() {
    const { t } = useTranslation();
    const [isDownloading, setIsDownloading] = useState(false);
    const handleDownloadConfig = async () => {
        setIsDownloading(true);
        try {
            const response = getColumnDefinitions(t);
            fileDownload(response, 'uv-column-configuration.csv');
            showToast('Success', 'Column configuration downloaded successfully');
        }
        catch (error) {
            console.log('Error in Downloading Column Configuration', error);
            showToast(error.message || 'Unknown error', 'Failed to download column configuration', 'error');
        }
        finally {
            setIsDownloading(false);
        }
    };
    return (React.createElement(Layout, { activeTab: VIEWS.COLUMN_CONFIG.name, sidebarDefaultState: SIDEBAR_STATUSES.EXPANDED },
        React.createElement("div", { className: "px-4 sm:px-6 lg:px-8" },
            React.createElement("div", { className: "max-w-3xl mx-auto" },
                React.createElement("div", { className: "bg-white shadow sm:rounded-lg" },
                    React.createElement("div", { className: "px-4 py-5 sm:p-6" },
                        React.createElement("h3", { className: "text-lg leading-6 font-medium text-gray-900 mb-4" }, t('COLUMN_CONFIGURATION')),
                        React.createElement("p", { className: "text-sm text-gray-600 mb-6" }, t('COLUMN_CONFIGURATION_DESCRIPTION')),
                        React.createElement("div", { className: "flex" },
                            React.createElement("button", { type: "button", onClick: handleDownloadConfig, disabled: isDownloading, className: "inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md text-white bg-green-600 hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-500 disabled:bg-gray-400 disabled:cursor-not-allowed" },
                                React.createElement(DocumentArrowDownIcon, { className: "-ml-1 mr-2 h-5 w-5", "aria-hidden": "true" }),
                                isDownloading ? 'Downloading...' : t('DOWNLOAD')))))))));
}
